<template>
  <div>
    <div class="row my-2 d-flex">
      <div class="col-lg-6 col-md-6 col-12 text-title">PAYMENT</div>
    </div>
    <div class="d-flex flex-wrap w-100 m-header align-items-center payment-mode-bar">
      <h3 class="title-page mb-0 payment-mode-title">Payment Mode</h3>
      <div class="s-menuset">
        <!-- Not searchable on purpose: a search box here is an <input> with
             no autocomplete attribute, which Chrome happily autofills with
             the saved login email — and four fixed options need no filter. -->
        <Multiselect
          :searchable="false"
          autocomplete="off"
          v-model="payment_mode"
          :options="payment_modes"
          :canClear="false"
        />
      </div>
      <!-- ShopBack is a KIOSK-only payment method and Qlub a MOO-only one,
           never a merchant-wide default — the backend rejects both as a
           default_payment_mode. -->
      <material-button
        v-if="!isShopback && !isQlub"
        class="btn mb-0 btn-success btn-md btn-background"
        :disabled="payment_mode === default_payment_mode"
        @click="saveDefaultPaymentMode"
      >
        Save as default
      </material-button>
      <span v-if="isShopback" class="text-muted">
        ShopBack is available on KIOSK only.
      </span>
      <span v-else-if="isQlub" class="text-muted">
        Qlub is available on MOO only (Pay First). Turn it on per outlet in Store settings.
      </span>
      <span v-else-if="default_payment_mode" class="text-muted">
        Current default: <strong>{{ paymentModeLabel(default_payment_mode) }}</strong>
      </span>
    </div>
    <div
      v-if="payment_mode === AIRWALLEX"
      class="col-lg-12 col-md-12 col-12 mt-3 m-header text-danger"
    >
      By using these payment services, you agree to T&amp;C
      <a
        href="https://www.airwallex.com/global/terms/scale-user-terms-global"
        target="_blank"
        rel="noopener noreferrer"
        class="text-danger text-decoration-underline"
      >
        here
      </a>
    </div>
    <div v-else class="col-lg-12 col-md-12 col-12 mt-3 m-header">
      Your're getting our highest level of payment protection and support while
      offering buyers the most payment options.
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto">
            <div class="row mt-3">
              <div class="col-12">
                <h3 class="title-page">MERCHANT</h3>
              </div>
              <div class="col-12 mt-3">
                <div class="card-custom">
                  <div class="table-responsive p-0 custom-table table-stack-host">
                    <table class="table align-items-center mb-0 table-stack-mobile">
                      <thead>
                        <tr>
                          <th class="text-center font-weight-bolder w-20">
                            {{ $t("name") }}
                          </th>
                          <th class="text-center font-weight-bolder">
                            {{ $t("merchantCode") }}
                          </th>
                          <th v-if="payment_mode == ALLINPAY" class="text-center font-weight-bolder w-20">
                            {{ $t("accessCode") }}
                          </th>
                          <th v-if="payment_mode === AIRWALLEX" class="text-center font-weight-bolder w-20">
                            {{ $t("airwallexBalance.colAccountId") }}
                          </th>
                          <th class="text-center font-weight-bolder w-20">
                            {{ fourthColumnLabel }}
                          </th>
                          <th v-if="payment_mode === AIRWALLEX" class="text-center font-weight-bolder w-20">
                            {{ $t("airwallexBalance.colCreatedAt") }}
                          </th>
                          <th class="text-center font-weight-bolder w-20"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-center text-xss w-20" :data-label="$t('name')">
                            {{ merchantName }}
                          </td>
                          <td class="text-center text-xss w-20" :data-label="$t('merchantCode')">
                            {{ merchantCodeFormated }}
                          </td>
                          <td v-if="payment_mode == ALLINPAY" class="text-center text-xss w-20" :data-label="$t('accessCode')">
                            {{ access_code }}
                          </td>
                          <td v-if="payment_mode === AIRWALLEX" class="text-center text-xss w-20" :data-label="$t('airwallexBalance.colAccountId')">
                            {{ airwallexAccountId || '-' }}
                          </td>
                          <td class="text-center text-xss w-20" :data-label="fourthColumnLabel">
                            <template v-if="payment_mode === ALLINPAY">{{ auth_mcht_id }}</template>
                            <template v-else-if="isShopback">{{ shopback_pos_id }}</template>
                            <template v-else-if="isQlub">{{ qlub_restaurant_slug }}</template>
                            <template v-else-if="payment_mode === AIRWALLEX">
                              <template v-if="airwallexBadge">
                                <span class="badge" :class="airwallexBadgeClass(airwallexBadge)">
                                  {{ airwallexBadgeLabel(airwallexBadge) }}
                                </span>
                                <div v-if="airwallexBadge === 'ACTIVE' && airwallexOpenRfiCount" class="text-warning text-xxs mt-1">
                                  Information requested
                                </div>
                              </template>
                              <span v-else class="text-muted">Not connected</span>
                            </template>
                            <template v-else>
                              <template v-if="stripe_user_id">{{ stripe_user_id }}</template>
                              <span v-else-if="stripe_user_id_connecting" class="text-muted fst-italic" style="opacity: 0.5;">{{ stripe_user_id_connecting }}</span>
                            </template>
                          </td>
                          <td v-if="payment_mode === AIRWALLEX" class="text-center text-xss w-20" :data-label="$t('airwallexBalance.colCreatedAt')">
                            {{ airwallexCreatedAt ? formatDate(airwallexCreatedAt) : '-' }}
                          </td>
                          <td class="text-center text-xss w-20 cell-actions">
                            <div v-if="payment_mode === ALLINPAY">
                              <material-button
                                class="btn mb-0 btn-success btn-md btn-background"
                                @click="handleConnectAllinpay()"
                              >
                                {{
                                  auth_mcht_id || access_code
                                    ? "Edit"
                                    : "Connect"
                                }}
                              </material-button>
                            </div>
                            <div v-else-if="isShopback">
                              <material-button
                                class="btn mb-0 btn-success btn-md btn-background"
                                @click="handleConnectShopback()"
                              >
                                {{ shopback_pos_id ? "Edit" : "Connect" }}
                              </material-button>
                            </div>
                            <div v-else-if="isQlub">
                              <material-button
                                class="btn mb-0 btn-success btn-md btn-background"
                                @click="handleConnectQlub()"
                              >
                                {{ qlub_restaurant_slug ? "Edit" : "Connect" }}
                              </material-button>
                            </div>
                            <div v-else-if="payment_mode === AIRWALLEX" class="ps-2">
                              <material-button
                                class="btn mb-0 btn-success btn-md btn-background"
                                :class="airwallexButtonClass(airwallexBadge)"
                                @click="handleConnectAirwallex()"
                              >
                                {{ airwallexButtonLabel(airwallexBadge) }}
                              </material-button>
                            </div>
                            <div v-else class="ps-2">
                              <material-button
                                class="btn mb-0 btn-md btn-background"
                                :class="stripeButtonClass(stripe_user_id, stripe_user_id_connecting)"
                                @click="handleStripeAccount()"
                              >
                                {{ stripeButtonLabel(stripe_user_id, stripe_user_id_connecting) }}
                              </material-button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <h3 class="title-page">PHYSICAL BRANCH</h3>
              <div class="col-12 mt-3">
                <div class="card-custom">
                  <div class="table-responsive p-0 custom-table table-stack-host">
                    <table class="table align-items-center mb-0 table-stack-mobile">
                      <thead>
                        <tr>
                          <th class="text-center font-weight-bolder w-20">
                            {{ $t("airwallexBalance.colPhysicalBranchName") }}
                          </th>
                          <th class="text-center font-weight-bolder w-20">
                            {{ $t("airwallexBalance.colPhysicalBranchId") }}
                          </th>
                          <th v-if="payment_mode == ALLINPAY" class="text-center font-weight-bolder w-20">
                            {{ $t("accessCode") }}
                          </th>
                          <th v-if="payment_mode == AIRWALLEX" class="text-center font-weight-bolder w-20">
                            {{ $t("airwallexBalance.colAccountId") }}
                          </th>
                          <th class="text-center font-weight-bolder w-20">
                            {{ fourthColumnLabel }}
                          </th>
                          <th v-if="payment_mode == AIRWALLEX" class="text-center font-weight-bolder w-20">
                            {{ $t("airwallexBalance.colCreatedAt") }}
                          </th>
                          <th class="text-center font-weight-bolder w-20"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(physicalBranch, index) in physicalBranches"
                          :key="index"
                        >
                          <td class="text-center text-xss w-20" :data-label="$t('airwallexBalance.colPhysicalBranchName')">
                            {{ physicalBranch.name }}
                          </td>
                          <td class="text-center text-xss w-20" :data-label="$t('airwallexBalance.colPhysicalBranchId')">
                            {{ physicalBranch.id }}
                          </td>
                          <td v-if="payment_mode == ALLINPAY" class="text-center text-xss w-20" :data-label="$t('accessCode')">
                            {{ physicalBranch.access_code }}
                          </td>
                          <td v-if="payment_mode == AIRWALLEX" class="text-center text-xss w-20" :data-label="$t('airwallexBalance.colAccountId')">
                            {{ physicalBranch.airwallex_account_id || '-' }}
                          </td>
                          <td class="text-center text-xss w-20" :data-label="fourthColumnLabel">
                            <template v-if="payment_mode == ALLINPAY">{{ physicalBranch.auth_mcht_id }}</template>
                            <template v-else-if="isShopback">{{ physicalBranch.shopback_pos_id }}</template>
                            <template v-else-if="isQlub">{{ physicalBranch.qlub_restaurant_slug }}</template>
                            <template v-else-if="payment_mode == AIRWALLEX">
                              <template v-if="branchAirwallexBadge(physicalBranch)">
                                <span class="badge" :class="airwallexBadgeClass(branchAirwallexBadge(physicalBranch))">
                                  {{ airwallexBadgeLabel(branchAirwallexBadge(physicalBranch)) }}
                                </span>
                                <div
                                  v-if="branchAirwallexBadge(physicalBranch) === 'ACTIVE' && physicalBranch.airwallex_open_rfi_count"
                                  class="text-warning text-xxs mt-1"
                                >
                                  Information requested
                                </div>
                              </template>
                              <span v-else class="text-muted">Not connected</span>
                            </template>
                            <template v-else>
                              <template v-if="physicalBranch.stripe_user_id">{{ physicalBranch.stripe_user_id }}</template>
                              <span v-else-if="physicalBranch.stripe_user_id_connecting" class="text-muted fst-italic" style="opacity: 0.5;">{{ physicalBranch.stripe_user_id_connecting }}</span>
                            </template>
                          </td>
                          <td v-if="payment_mode == AIRWALLEX" class="text-center text-xss w-20" :data-label="$t('airwallexBalance.colCreatedAt')">
                            {{ physicalBranch.airwallex_created_at ? formatDate(physicalBranch.airwallex_created_at) : '-' }}
                          </td>
                          <td class="text-center text-xss w-20 cell-actions">
                            <div v-if="payment_mode === ALLINPAY">
                              <material-button
                                class="btn mb-0 btn-success btn-md btn-background"
                                @click="handleConnectAllinpay(
                                  2,
                                  physicalBranch.id,
                                  physicalBranch.access_code,
                                  physicalBranch.auth_mcht_id
                                )"
                              >
                                {{
                                  physicalBranch.auth_mcht_id || physicalBranch.access_code
                                    ? "Edit"
                                    : "Connect"
                                }}
                              </material-button>
                            </div>
                            <div v-else-if="isShopback">
                              <material-button
                                class="btn mb-0 btn-success btn-md btn-background"
                                @click="handleConnectShopback(
                                  2,
                                  physicalBranch.id,
                                  physicalBranch.shopback_pos_id
                                )"
                              >
                                {{ physicalBranch.shopback_pos_id ? "Edit" : "Connect" }}
                              </material-button>
                            </div>
                            <div v-else-if="isQlub">
                              <material-button
                                class="btn mb-0 btn-success btn-md btn-background"
                                @click="handleConnectQlub(
                                  2,
                                  physicalBranch.id,
                                  physicalBranch.qlub_restaurant_slug,
                                  physicalBranch.qlub_redirect_key
                                )"
                              >
                                {{ physicalBranch.qlub_restaurant_slug ? "Edit" : "Connect" }}
                              </material-button>
                            </div>
                            <div v-else-if="payment_mode === AIRWALLEX" class="ps-2">
                              <material-button
                                class="btn mb-0 btn-success btn-md btn-background"
                                :class="airwallexButtonClass(branchAirwallexBadge(physicalBranch))"
                                @click="handleConnectAirwallex(physicalBranch.id, branchAirwallexBadge(physicalBranch))"
                              >
                                {{ airwallexButtonLabel(branchAirwallexBadge(physicalBranch)) }}
                              </material-button>
                            </div>
                            <div v-else class="ps-2">
                              <material-button
                                :disabled="!stripe_user_id && !physicalBranch.stripe_user_id && !physicalBranch.stripe_user_id_connecting"
                                class="btn mb-0 btn-md btn-background"
                                :class="stripeButtonClass(physicalBranch.stripe_user_id, physicalBranch.stripe_user_id_connecting)"
                                @click="
                                  handleStripeAccount(
                                    2,
                                    physicalBranch.id,
                                    physicalBranch.stripe_user_id,
                                    physicalBranch.stripe_user_id_connecting
                                  )
                                "
                              >
                                {{ stripeButtonLabel(physicalBranch.stripe_user_id, physicalBranch.stripe_user_id_connecting) }}
                              </material-button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :current_page="pagination.current_page"
                    :last_page="pagination.last_page"
                  />
                </div>
              </div>
            </div>
            <div v-if="payment_mode === AIRWALLEX" class="mt-4">
              <router-link to="/airwallex-balance" class="btn mb-0 btn-success btn-md btn-background airwallex-balance-link">
                {{ $t("airwallexBalance.openFromPayments") }}
              </router-link>
            </div>
            <AirwallexTransferList v-if="payment_mode === AIRWALLEX" />
            <div v-if="payment_mode == ALLINPAY" class="row mt-5">
              <h3 class="title-page">PUBLIC KEY</h3>
              <div>Set the public key for the Allinpay merchant you want to use, then retrieve the merchant ID from Allinpay and add it to minty.</div>
              <div class="col-12 mt-3">
                <material-textarea v-model="serverPublicKey" :readonly="true" :showCopyButton="true" :rows="10" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <ModalChooseConnectOption
      :getLinkConnect="getLinkConnect"
      :connectExistingAccount="connectExistingAccount"
    ></ModalChooseConnectOption>
    <ModalConnectExistingAccount
      :type="type"
      :physicalBranchId="physicalBranchId"
      :merchantId="merchantId"
      :keyReload="keyReloadConnectExistingAccount"
      :getList="getList"
    ></ModalConnectExistingAccount>
    <ModalConnectAllinpay
      :type="type"
      :physicalBranchId="physicalBranchId"
      :merchantId="merchantId"
      :keyReload="keyReloadConnectExistingAccount"
      :getList="getList"
      :accessCodeSelected="access_code_selected"
      :authMchtIdSelected="auth_mcht_id_selected"
    ></ModalConnectAllinpay>
    <ModalConnectAirwallex
      :merchantId="merchantId"
      :merchantEmail="merchantEmail"
      :physicalBranchId="airwallexBranchId"
      :airwallexBadge="airwallexModalBadge"
      :keyReload="keyReloadConnectAirwallex"
      :getList="getList"
    ></ModalConnectAirwallex>
    <ModalConnectShopback
      :type="type"
      :physicalBranchId="physicalBranchId"
      :merchantId="merchantId"
      :keyReload="keyReloadConnectExistingAccount"
      :getList="getList"
      :posIdSelected="shopback_pos_id_selected"
    ></ModalConnectShopback>
    <ModalConnectQlub
      :type="type"
      :physicalBranchId="physicalBranchId"
      :keyReload="keyReloadConnectExistingAccount"
      :getList="getList"
      :restaurantSlugSelected="qlub_restaurant_slug_selected"
      :redirectKeySelected="qlub_redirect_key_selected"
    ></ModalConnectQlub>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Pagination from "@/components/Pagination.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import PaymentService from "../../services/payment.service";
import MaterialButton from "@/components/MaterialButton.vue";
import ModalChooseConnectOption from "./components/ModalChooseConnectOption.vue";
import ModalConnectExistingAccount from "./components/ModalConnectExistingAccount.vue";
import ModalConnectAllinpay from "./components/ModalConnectAllinpay.vue";
import ModalConnectAirwallex from "./components/ModalConnectAirwallex.vue";
import ModalConnectShopback from "./components/ModalConnectShopback.vue";
import ModalConnectQlub from "./components/ModalConnectQlub.vue";
import AirwallexTransferList from "./components/AirwallexTransferList.vue";
import { airwallexBadgeLabel, airwallexBadgeClass } from "./airwallexBadge";
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import MaterialTextarea from "@/components/MaterialTextarea.vue";

export default {
  name: "find-store",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    Pagination,
    MaterialButton,
    ModalChooseConnectOption,
    ModalConnectExistingAccount,
    ModalConnectAllinpay,
    ModalConnectAirwallex,
    ModalConnectShopback,
    ModalConnectQlub,
    AirwallexTransferList,
    Multiselect,
    MaterialTextarea
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      pagination: {},
      page: 1,
      merchantCode: "",
      merchantCodeFormated: "",
      merchantId: "",
      merchantName: "",
      stripe_user_id: "",
      stripe_user_id_connecting: "",
      access_code: "",
      auth_mcht_id: "",
      access_code_selected: "",
      auth_mcht_id_selected: "",
      // POS ID is the only per-merchant ShopBack setting — the keypair lives
      // in the KIOSK API's .env, not on the merchant.
      shopback_pos_id: "",
      shopback_pos_id_selected: "",
      // Qlub restaurant slug + redirect key: one pair per Qlub restaurant.
      qlub_restaurant_slug: "",
      qlub_redirect_key: "",
      qlub_restaurant_slug_selected: "",
      qlub_redirect_key_selected: "",
      physicalBranches: [],
      type: 1, // 1: merchant connect, 2: physical branch connect
      physicalBranchId: 0,
      keyReloadConnectExistingAccount: "keyReloadConnectExistingAccount",
      payment_mode: 1,
      // Default payment mode saved on the backend (minty_mer_settings.default_payment_mode).
      // The Multiselect above is a view toggle; this field holds the persisted default
      // so we can disable "Save as default" when no change has been made.
      default_payment_mode: 1,
      // Guards the one-time adoption of default_payment_mode in getList().
      payment_mode_initialised: false,
      payment_modes: [
        { value: 1, label: "Stripe" },
        { value: 2, label: "AllInPay" },
        { value: 3, label: "Airwallex" },
        { value: 4, label: "ShopBack" },
        { value: 5, label: "Qlub" },
      ],
      ALLINPAY: 2,
      AIRWALLEX: 3,
      SHOPBACK: 4,
      QLUB: 5,
      serverPublicKey: "",
      merchantEmail: "",
      airwallexStatus: "",
      airwallexBadgeValue: "",
      airwallexOpenRfiCount: 0,
      airwallexAccountId: "",
      airwallexCreatedAt: "",
      airwallexBranchId: 0,
      airwallexModalBadge: "",
      keyReloadConnectAirwallex: "keyReloadConnectAirwallex"
    };
  },
  async created() {
    const merchant_code = localStorage.getItem("MERCHANT_CODE") || "";
    const name = localStorage.getItem("MERCHANT_ADMIN_NAME") || "";
    this.merchantCode = merchant_code ? `/${merchant_code}` : "";
    this.merchantCodeFormated = merchant_code;
    this.merchantName = name;
    this.merchantId = localStorage.getItem("MERCHANT_ID") || "";

    if (this.$route.query.account_id) {
      this.showLoader();
      let physicalBranchId = this.$route.query.physical_branch_id ?? 0;
      
      let dataForm = {
        type: physicalBranchId ? 2 : 1, // 1: merchant connect, 2: physical branch connect
        account_id: this.$route.query.account_id ?? '',
        merchant_id: this.$route.query.merchant_id ?? 0,
        physical_branch_id: physicalBranchId,
      };

      await PaymentService.connectExistingAccount(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Connect Successfully!";
            this.$router.replace({ query: null });
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    }

    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }

    // Handle Airwallex return redirect
    if (this.$route.query.payment_mode) {
      this.payment_mode = parseInt(this.$route.query.payment_mode);
      // The tab the user came back to wins over the saved default. getList()
      // cannot read it from the URL: the query is cleared below, before its
      // response arrives.
      this.payment_mode_initialised = true;
      const returnedBranchId = parseInt(this.$route.query.physical_branch_id) || 0;
      let query = Object.assign({}, this.$route.query);
      delete query.payment_mode;
      if (this.payment_mode === this.AIRWALLEX) {
        delete query.physical_branch_id;
      }
      this.$router.replace({ query: Object.keys(query).length ? query : undefined });

      if (this.payment_mode === this.AIRWALLEX) {
        // The refresh calls Airwallex (a second or two) before the list loads.
        this.showLoader();
        // Back from an Airwallex form: re-read that account before listing it,
        // instead of waiting for the webhook. A failure only means the list
        // shows the last stored state.
        await PaymentService.airwallexOnboardingStatus({
          merchant_id: this.merchantId,
          physical_branch_id: returnedBranchId || undefined,
          refresh: 1,
        }).catch(() => {});
        // Airwallex can take a few minutes to process what was just sent (an
        // answered RFI still reads as open right after), so say so instead of
        // letting the old badge look like the submission failed.
        this.snackbar = "success";
        this.message = "Back from Airwallex. The status can take a few minutes to update.";
        this.setTimeOutNotification();
      }
    }

    this.getList(this.page);
  },
  computed: {
    isShopback() {
      return this.payment_mode == this.SHOPBACK;
    },

    isQlub() {
      return this.payment_mode == this.QLUB;
    },

    // The 4th column carries a different value per gateway, so its heading
    // moved out of the template once ShopBack made the inline ternary a
    // four-way one.
    fourthColumnLabel() {
      if (this.payment_mode == this.ALLINPAY) return this.$t("merchantID");
      if (this.payment_mode == this.AIRWALLEX) return "Status";
      if (this.isShopback) return this.$t("posId");
      if (this.isQlub) return "Restaurant Slug";
      return this.$t("stripeAccount");
    },

    airwallexBadge() {
      return this.airwallexBadgeFor(this.airwallexBadgeValue, this.airwallexStatus);
    }
  },
  methods: {
    formatDate(dt) {
      if (!dt) return "";
      const d = new Date(dt);
      if (isNaN(d.getTime())) return dt;
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    getLinkConnect() {
      this.showLoader();
      $(".hide-modal-choose-connect-option").click();
      let dataForm = {
        type: this.type,
        physical_branch_id: this.physicalBranchId,
      };

      PaymentService.getLinkConnect(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            window.location.href = response.data.data.url;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    connectExistingAccount() {
      $(".hide-modal-choose-connect-option").click();
      this.keyReloadConnectExistingAccount = Math.random().toString();
      $(".show-modal-connect-existing-account").click();
    },

    handleStripeAccount(
      type = 1, // 1: merchant connect, 2: physical branch connect
      physicalBranchId = 0,
      physicalBranchStripeUserId = "",
      physicalBranchStripeUserIdConnecting = ""
    ) {
      this.type = type;
      this.physicalBranchId = physicalBranchId;

      let stripeUserId;
      let stripeUserIdConnecting;

      if (physicalBranchId) {
        stripeUserId = physicalBranchStripeUserId;
        stripeUserIdConnecting = physicalBranchStripeUserIdConnecting;
        localStorage.setItem("PHYSICAL_BRANCH_ID", physicalBranchId);
      } else {
        stripeUserId = this.stripe_user_id;
        stripeUserIdConnecting = this.stripe_user_id_connecting;
        localStorage.removeItem("PHYSICAL_BRANCH_ID");
      }

      // View Payout: stripe_user_id present
      if (stripeUserId) {
        this.showLoader();
        PaymentService.getLinkPayout(
          stripeUserId,
          this.merchantCodeFormated
        ).then(
          (response) => {
            if (response.data.result.isSuccess) {
              window.open(response.data.data.url);
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
        return;
      }

      // Continue: only stripe_user_id_connecting present → create connect link directly
      if (stripeUserIdConnecting) {
        this.getLinkConnect();
        return;
      }

      // Connect: both null → open modal to choose connect option
      $(".show-modal-choose-connect-option").click();
    },

    handleConnectAllinpay(type = 1, // 1: merchant connect, 2: physical branch connect
      physicalBranchId = 0,
      accessCode = '',
      authMchtId = ''
    ) {
      this.type = type;
      this.physicalBranchId = physicalBranchId;
      this.access_code_selected = type == 1 ? this.access_code : accessCode;
      this.auth_mcht_id_selected = type == 1 ? this.auth_mcht_id : authMchtId;
      this.keyReloadConnectExistingAccount = Math.random().toString();
      $(".show-modal-connect-allinpay").click();
    },

    handleConnectShopback(type = 1, // 1: merchant connect, 2: physical branch connect
      physicalBranchId = 0,
      posId = ''
    ) {
      this.type = type;
      this.physicalBranchId = physicalBranchId;
      this.shopback_pos_id_selected = type == 1 ? this.shopback_pos_id : (posId || '');
      this.keyReloadConnectExistingAccount = Math.random().toString();
      $(".show-modal-connect-shopback").click();
    },

    handleConnectQlub(type = 1, // 1: merchant connect, 2: physical branch connect
      physicalBranchId = 0,
      restaurantSlug = '',
      redirectKey = ''
    ) {
      this.type = type;
      this.physicalBranchId = physicalBranchId;
      this.qlub_restaurant_slug_selected = type == 1 ? this.qlub_restaurant_slug : (restaurantSlug || '');
      this.qlub_redirect_key_selected = type == 1 ? this.qlub_redirect_key : (redirectKey || '');
      this.keyReloadConnectExistingAccount = Math.random().toString();
      $(".show-modal-connect-qlub").click();
    },

    handleConnectAirwallex(branchId = 0, branchBadge = "") {
      this.airwallexBranchId = branchId;
      this.airwallexModalBadge = branchId ? branchBadge : this.airwallexBadge;
      this.keyReloadConnectAirwallex = Math.random().toString();
      $(".show-modal-connect-airwallex").click();
    },

    // The badge the API computed. A row not synced since the badge column was
    // added only has the raw Airwallex status, so read that the same way.
    airwallexBadgeFor(badge, status) {
      if (badge) return badge;
      if (!status) return "";
      const fromStatus = {
        CREATED: "KYC_NOT_SUBMITTED",
        CONNECTED: "KYC_NOT_SUBMITTED",
        SUBMITTED: "KYC_IN_REVIEW",
        ACTION_REQUIRED: "INFORMATION_REQUIRED",
        ACTIVE: "ACTIVE",
      };
      // SUSPENDED needs the activation history to tell FROZEN from REJECTED;
      // until the API has synced the row, show the raw status.
      return fromStatus[status] || status;
    },

    branchAirwallexBadge(physicalBranch) {
      return this.airwallexBadgeFor(physicalBranch.airwallex_badge, physicalBranch.airwallex_status);
    },

    airwallexBadgeLabel,

    airwallexBadgeClass,

    airwallexButtonLabel(badge) {
      if (!badge) return "Connect";
      if (badge === "ACTIVE") return "Connected";
      if (badge === "KYC_NOT_SUBMITTED") return "Continue";
      if (badge === "INFORMATION_REQUIRED") return "Action needed";
      return "View";
    },

    airwallexButtonClass(badge) {
      if (badge === "ACTIVE") return "bg-success";
      if (["KYC_NOT_SUBMITTED", "INFORMATION_REQUIRED", "KYC_IN_REVIEW"].includes(badge)) return "bg-primary";
      return "bg-secondary";
    },

    stripeButtonLabel(stripeUserId, stripeUserIdConnecting) {
      if (stripeUserId) return this.$t("viewPayout");
      if (stripeUserIdConnecting) return "Continue";
      return "Connect";
    },

    stripeButtonClass(stripeUserId, stripeUserIdConnecting) {
      if (stripeUserId) return "bg-success";
      if (stripeUserIdConnecting) return "bg-primary";
      return "";
    },

    paymentModeLabel(value) {
      const found = this.payment_modes.find((m) => m.value === value);
      return found ? found.label : "";
    },

    saveDefaultPaymentMode() {
      this.showLoader();
      PaymentService.saveDefaultPaymentMode({ payment_mode: this.payment_mode }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.default_payment_mode = response.data.data.default_payment_mode;
            this.snackbar = "success";
            this.message = "Default payment mode saved";
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error?.response?.data?.result?.message ?? "Save failed";
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    getList(page) {
      this.showLoader();
      PaymentService.getStripeConnectInfoByMerchant({
        page: page,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.stripe_user_id =
              response.data.data.merchant_admin.stripe_user_id;
            this.stripe_user_id_connecting =
              response.data.data.merchant_admin.stripe_user_id_connecting;
            this.access_code =
              response.data.data.merchant_admin.access_code;
            this.auth_mcht_id =
              response.data.data.merchant_admin.auth_mcht_id;
            this.shopback_pos_id =
              response.data.data.merchant_admin.shopback_pos_id ?? "";
            this.qlub_restaurant_slug =
              response.data.data.merchant_admin.qlub_restaurant_slug ?? "";
            this.qlub_redirect_key =
              response.data.data.merchant_admin.qlub_redirect_key ?? "";
            this.serverPublicKey = response.data.data.server_public_key;
            this.merchantEmail = response.data.data.merchant_admin.company_email || '';
            this.airwallexStatus = response.data.data.merchant_admin.airwallex_status || '';
            this.airwallexBadgeValue = response.data.data.merchant_admin.airwallex_badge || '';
            this.airwallexOpenRfiCount = response.data.data.merchant_admin.airwallex_open_rfi_count || 0;
            this.airwallexAccountId = response.data.data.merchant_admin.airwallex_account_id || '';
            this.airwallexCreatedAt = response.data.data.merchant_admin.airwallex_created_at || '';
            // Initialise both the view toggle and the persisted-default tracker.
            // If the URL carries ?payment_mode=, that override (handled in created())
            // wins for the toggle; default tracker still reflects DB.
            //
            // Only the FIRST load moves the toggle. getList() also runs after a
            // connect and on every page change, and adopting the saved default
            // there would throw the user back to it — e.g. saving a ShopBack
            // POS ID would bounce the screen to Stripe the moment the
            // modal closed. The default is applied again on reload/re-entry,
            // when created() runs afresh.
            const savedMode = parseInt(response.data.data.merchant_admin.default_payment_mode) || 1;
            this.default_payment_mode = savedMode;
            if (!this.payment_mode_initialised) {
              this.payment_mode_initialised = true;

              if (!this.$route.query.payment_mode) {
                this.payment_mode = savedMode;
              }
            }
            this.physicalBranches = response.data.data.physical_branches.items;
            this.pagination = response.data.data.physical_branches;
            this.page = this.pagination.current_page;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

  },
};
</script>
<style scoped>
.text-title {
  color: #133067 !important;
  font-weight: 600 !important;
  font-size: 20px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.s-menuset .multiselect {
  margin: 0 !important;
  width: 400px !important;
  max-width: 100%;
}

.payment-mode-bar {
  gap: 12px 16px;
}

.payment-mode-title {
  width: 150px;
}

.bg-success {
  background: #198754 !important;
  background-image: none !important;
  color: #fff !important;
  border: 1px solid #198754 !important;
}

.bg-primary {
  background: #0d6efd !important;
  background-image: none !important;
  color: #fff !important;
  border: 1px solid #0d6efd !important;
}

.bg-info {
  background: #0dcaf0 !important;
  background-image: none !important;
  color: #000 !important;
  border: 1px solid #0dcaf0 !important;
}

.bg-warning {
  background: #ffc107 !important;
  background-image: none !important;
  color: #000 !important;
  border: 1px solid #ffc107 !important;
}

.bg-danger {
  background: #dc3545 !important;
  background-image: none !important;
  color: #fff !important;
  border: 1px solid #dc3545 !important;
}

.bg-secondary {
  background: #6c757d !important;
  background-image: none !important;
  color: #fff !important;
  border: 1px solid #6c757d !important;
}

@media (max-width: 768px) {
  .m-header {
    flex-direction: column;
    padding: 0 20px;
  }

  .m-header > div {
    margin-bottom: 10px;
  }

  .s-menuset {
    margin-right: 0 !important;
  }

  .s-menuset .multiselect {
    width: 100% !important;
  }

  /* Phone: one column, full-width controls, left-aligned text. */
  .payment-mode-bar {
    align-items: stretch !important;
    gap: 8px;
  }

  .payment-mode-bar > div {
    margin-bottom: 0;
  }

  .payment-mode-title {
    width: auto;
  }

  .airwallex-balance-link {
    display: block;
    width: 100%;
  }
}
</style>
